import React, { useEffect, useState } from 'react';
import { addSpace } from '../../Components/Tools';
import ApexCharts from 'react-apexcharts';
import axios from 'axios';
import qs from 'qs';

function BilanDynContribDirDot(props)
{
    const [series, setSeries] = useState(undefined)
    const [options, setOptions] = useState(undefined)

    useEffect(() => {

        var filename = "Dynamique impôts & taxes et dotations";

        /* Initialisation des options avec les années */
        var option_tmp = {
            chart: {
                toolbar: {
                    show: props.download?true:false,
                    export: {
                        svg: {
                          filename: filename.replace("'", '_').replace("/", '_').replace(".", ''),
                        },
                        png: {
                          filename: filename.replace("'", '_').replace("/", '_').replace(".", ''),
                        },
                        csv: {
                          filename: filename.replace("'", '_').replace("/", '_').replace(".", ''),
                        },
                    },
                },
                type: 'line',
            },
            stroke: {
              curve: 'smooth'
            },
            title: {
                text: filename
            },
            xaxis: {
                categories: props.annees
            },
            yaxis: {
                labels: {
                  formatter: function (value) {
                    return addSpace(Math.round(value*100)/100, true);
                  }
                },
            },
        }
        setOptions(option_tmp)

        axios.post('https://app-slfinance.fr/api/graph.php', qs.stringify({
        	'DynContribDirDot': true,
            'id_budget': props.user.id_budget,
            'annees': props.annees,
        }))
        .then(async (res) => {
            var tmp = [];
            if (props.affH1) {
                if (res.data[0][0] !== 0) {
                    await tmp.push({
                        name: "Dot. et participations H1",
                        data: res.data[0],
                        color: '#8e44ad',
                    })
                }
                if (res.data[1][0] !== 0) {
                    await tmp.push({
                        name: "Contributions directes + TVA H1",
                        data: res.data[1],
                        color: '#2980b9',
                    })
                }
            }
            if (props.affH2) {
                if (res.data[2][0] !== 0) {
                    await tmp.push({
                        name: "Dot. et participations H2",
                        data: res.data[2],
                        color: '#27ae60',
                    })
                }
                if (res.data[3][0] !== 0) {
                    await tmp.push({
                        name: "Contributions directes + TVA H2",
                        data: res.data[3],
                        color: '#f39c12',
                    })
                }
            }
            if (props.affH3) {
                if (res.data[4][0] !== 0) {
                    await tmp.push({
                        name: "Dot. et participations H3",
                        data: res.data[4],
                        color: '#7f8c8d',
                    })
                }
                if (res.data[5][0] !== 0) {
                    await tmp.push({
                        name: "Contributions directes + TVA H3",
                        data: res.data[5],
                        color: '#c0392b',
                    })
                }
            }
            await setSeries(tmp);
        })
    }, [props.aff])


	return (
		<div style={{margin: 5}}>
            {options && series?
			<ApexCharts
                series={series}
                options={options}
                width={'100%'}
                height={props.height?props.height:300}
                type="line"
            />:null}
		</div>
	)
}

export default BilanDynContribDirDot;
